import { render, staticRenderFns } from "./BarraganSM.vue?vue&type=template&id=4c37a395&scoped=true&"
import script from "./BarraganSM.vue?vue&type=script&lang=js&"
export * from "./BarraganSM.vue?vue&type=script&lang=js&"
import style0 from "./BarraganSM.vue?vue&type=style&index=0&id=4c37a395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37a395",
  null
  
)

export default component.exports